import { Component } from "react";
import DataLoader, { toLegacyFetcher } from "./../../../../../DataLoader/DataLoader";
import SidePanelSection from "./../../../SidePanelSection/SidePanelSection";
import { Link } from "react-router-dom";
import { addItemToRecentTags, fetchTags, getRecentTags } from "services/tags";
import { useTranslation } from "react-i18next";
import { buildExerciseTagPath, isExerciseTagActive } from "pages/Exercises/urlState";

export default class TopicSection extends Component {
  render() {
    if (getRecentTags().length >= 3) {
      const tags = getRecentTags();
      return (
        <TopicSectionInner
          {...this.props}
          data={{ list: tags, total_count: tags.length }}
        />
      );
    } else {
      return (
        <DataLoader
          fetchData={toLegacyFetcher(fetchTags)}
          fetchArgs={{ page: 1, size: 5 }}
        >
          <TopicSectionInner {...this.props} />
        </DataLoader>
      );
    }
  }
}

function TopicSectionInner(props) {
  const { t } = useTranslation();

  return (
    <SidePanelSection
      sectionTitle={t("Common.Popular Topics")}
      list={props.data.list}
      location={props.location}
      tagName={TopicListItem}
      isReducedList={true}
    />
  );
}

class TopicListItem extends Component {
  handleClick = () => {
    addItemToRecentTags(this.props.item);
  };

  render() {
    const path = buildExerciseTagPath(this.props.item.id);
    const isActive = isExerciseTagActive(this.props.location, this.props.item.id);
    return (
      <li className={isActive ? "active" : ""}>
        <Link className="btn" onClick={this.handleClick} to={path}>
          {this.props.item.name}
        </Link>
      </li>
    );
  }
}
